var site = window.site || {};
(function($, Drupal) {
  var $document = $(document);
  Drupal.behaviors.bambuserBlockV1 = {
    getButtons: function($module, index) {
      var $triggers = $('.js-elc-button', $module);
      if ($triggers.length > 0) {
        $triggers = $triggers.eq(index - 1);
      }
      return $triggers;
    },

    attach: function(context, settings) {
      var self = this;
      var $modules = $('.js-bambuser-block', context);
      if (!settings.bambuser_config['source']) {
        return false;
      }
      if (!window.initBambuserLiveShopping) {
        window.initBambuserLiveShopping = function(item) {
          window.initBambuserLiveShopping.queue.push(item);
        };
        window.initBambuserLiveShopping.queue = [];
        var scriptNode = document.createElement('script');
        scriptNode['src'] = settings.bambuser_config['source'];
        document.body.appendChild(scriptNode);
      }
      $modules.each(function() {
        self.init($(this));
      });
    },

    init: function($module) {
      var self = this;
      var index = $module.data('buttonIndex') || false;
      var streamId = $module.data('streamId');
      if (streamId.length > 0) {
        streamId = streamId.trim();
      }
      var linkImage = $module.data('linkImage');
      if (linkImage) {
        var $images = $('.js-content-block-link', $module);
        $images.each(function() {
          self.setup($(this), streamId);
        });
      }
      if (!!index) {
        var $elements = self.getButtons($module, index);
        $elements.each(function() {
          self.setup($(this), streamId);
        });
      }
    },

    setup: function($elem, streamId) {
      if (($elem && $elem.length < 1) || $elem.hasClass('bambuser-initialized')) {
        return false;
      }
      var randomId = 'bambuser-trigger-' + Math.random().toString(36).substr(2, 9);
      if (!$elem.is('a')) {
        $elem.addClass('bambuser-clickable');
      }
      $elem.attr({
        'id': randomId,
        'role': 'button',
        'tabindex': 0,
        'href': 'javascript:void(0);',
      }).addClass('bambuser-initialized');
      window.initBambuserLiveShopping({
        showId: streamId,
        node: document.getElementById(randomId),
        type: 'overlay',
      });
      $elem.once('click.activate', function() {
        $document.trigger('bambuser.launched');
      });
      window.onBambuserLiveShoppingReady = function(player) {
        player.on(player.EVENT.PROVIDE_PRODUCT_DATA, function(event) {
          var cleanedProductURL = function(url) {
            var cleanURL = new URL(url);
            cleanURL.hostname = location.hostname;
            return cleanURL.href;
          };
          event.products.forEach(function(product) {
            player.updateProduct(product.id, function(productFactory) {
              var finalProduct = productFactory.inheritFromPlaceholder();
              var bambuserSettings = Drupal.settings.bambuser;
              var currency = bambuserSettings && bambuserSettings.currency || 'USD';
              var locale = bambuserSettings && bambuserSettings.locale || 'en_US';
              finalProduct.publicUrl(cleanedProductURL(product.url));
              finalProduct.currency(currency);
              finalProduct.locale(locale);
              return finalProduct;
            });
          });
        });
        player.configure({
          locale: $.cookie('LOCALE').replace('_', '-'),
          buttons: {
            dismiss: player.BUTTON.MINIMIZE,
            product: player.BUTTON.MINIMIZE,
          },
        });
      };
    },

  };
})(jQuery, Drupal);
